import { render, staticRenderFns } from "./ProgressLabel.vue?vue&type=template&id=4047fb6a&scoped=true&"
import script from "@/views/Users/Student/Progress/ProgressLabel.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Student/Progress/ProgressLabel.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Student/Progress/progress-label.scss?vue&type=style&index=0&id=4047fb6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4047fb6a",
  null
  
)

export default component.exports